import { render } from "./CircularEconomyProject.vue?vue&type=template&id=54e2e4a4"
import script from "./CircularEconomyProject.vue?vue&type=script&lang=js"
export * from "./CircularEconomyProject.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__